import { Navigate } from 'react-router-dom';
import { auth } from '../services';

/**
 * PublicRoute Component
 * Redirects to the role home page if user is already authenticated
 */
const PublicRoute = ({ children }) => {
  const isAuthenticated = auth.isAuthenticated();

  if (isAuthenticated) {
    return <Navigate to={auth.getHomePath()} replace />;
  }

  return children;
};

export default PublicRoute;
